<input
  type="file"
  [id]="internalId"
  (change)="fileChangeHandler($event)"
  style="display: none"
/>

<label
  *ngIf="!internalPhoto"
  [for]="internalId"
  class="file-display file-upload"
>
  <div><i-feather class="upload-icon" name="upload-cloud"></i-feather></div>
  <span class="upload-text">
    <strong>{{ label }}</strong>
    <br />
    <small>(10 Mo max)</small>
  </span>
</label>

<div *ngIf="internalPhoto" class="file-display position-relative">
  <img
    [src]="internalPhoto"
    alt="miniature"
    class="img-thumbnail"
    (click)="changePhoto()"
  />
  <button class="delete-icon" (click)="removePhoto()">✖</button>
</div>
